import React, { Component } from 'react';
import axios from 'axios';
import { BigBold } from './LayoutComponents';

export class Signup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showOption: '',
      userName: '',
      userTitle: '',
      selectDay: 0,
      selectMeal: 0,
      userNameInvalid: false,
      selectDayInvalid: false,
      selectMealInvalid: false,
    };
  }

  getDayIndex() {
    switch(this.state.selectDay) {
      case "- 선택 하기 -":
        return "0";
      case "일요일 (Sun)":
        return "1";
      case "월요일 (Mon)":
        return "2";
      case "화요일 (Tue)":
        return "3";
      case "수요일 (Wed)":
        return "4";
      case "목요일 (Thu)":
        return "5";
      case "금요일 (Fri)":
        return "6";
      case "토요일 (Sat)":
        return "7";
      default:
        return "0";
    }
  }

  getMealIndex() {
    switch(this.state.selectMeal) {
      case "- 선택 하기 -":
        return "0";
      case "아침 (Breakfast)":
        return "1";
      case "점심 (Lunch)":
        return "2";
      case "저녁 (Dinner)":
        return "3";
      default:
        return "0";
    }
  }

  async registerDay() {
    this.setState({
      userNameInvalid: (this.state.userName.length < 2), 
      selectDayInvalid: (this.state.selectDay < 1 || this.state.selectDay === '- 선택 하기 -'),
      selectMealInvalid: false
    });

    if((this.state.userName.length < 2) || (this.state.selectDay < 1 || this.state.selectDay === '- 선택 하기 -'))
      return;

    var response = axios.get('/signupuser', { params: { 
      pUser: this.state.userName,
      pTitle: this.state.userTitle,
      pDay: this.getDayIndex(),
      pMeal: "0", 
    } });

    try {
      const resultMessage = ((await response).data).toString();
      if (resultMessage.startsWith('Success')) {
        this.setState({showOption: 'confirmation'});
      }
    } 
    catch { }
  }

  async registerMeal() {
    this.setState({
      userNameInvalid: (this.state.userName.length < 2), 
      selectDayInvalid: (this.state.selectDay < 1 || this.state.selectDay === '- 선택 하기 -'),
      selectMealInvalid: (this.state.selectMeal < 1 || this.state.selectMeal === '- 선택 하기 -'),
    });

    if((this.state.userName.length < 2) || (this.state.selectDay < 1 || this.state.selectDay === '- 선택 하기 -') || (this.state.selectMeal < 1 || this.state.selectMeal === '- 선택 하기 -'))
      return;
      
    var response = axios.get('/signupuser', { params: { 
      pUser: this.state.userName,
      pTitle: this.state.userTitle,
      pDay: this.getDayIndex(),
      pMeal: this.getMealIndex(), 
    } });

    try {
      const resultMessage = ((await response).data).toString();
      if (resultMessage.startsWith('Success')) {
        this.setState({showOption: 'confirmation'});
      }
    } 
    catch { }
  }

  captureInput = e => {
    this.setState({[e.target.name]: e.target.value});
  };

  render() {
    return (
      <div>
        <h2>금식 참여 등록하기</h2>
        <br/>
        {this.state.showOption === '' && (
          <table width="100%"><tbody><tr>
            <td width="25%" />
            <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.setState({showOption: 'day'})}>주중 하루 금식</button></td>
            <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.setState({showOption: 'meal'})}>주중 한끼 금식</button></td>
            <td width="25%" />
          </tr></tbody></table>
        )}

        {this.state.showOption === 'day' && (
          <div>
            <hr/>
            <table><tbody>
              <tr>
                <td width="100px">
                  <span style={this.state.userNameInvalid ? 
                    {color:'red', textDecoration:'underline', fontWeight: 'bold'}: 
                    {color:'black', textDecoration:'none'}}>이름:</span>
                </td>
                <td width="280px">
                  <input type="text" name="userName" 
                    value={this.state.userName} 
                    onChange={this.captureInput} 
                    style={{width: '200px'}} />
                  </td>
                <td width="100px">직분:</td>
                <td width="280px">
                  <input type="text" name="userTitle" 
                    value={this.state.userTitle} 
                    onChange={this.captureInput} 
                   style={{width: '200px'}} />
                </td>
              </tr>
            </tbody></table>
            <hr/>
            <br />
            <b>주중 하루 금식</b>
            <br />
            <br />
            <table style={{marginLeft: '20px'}}><tbody>
              <tr>
                <td width="100px">
                  <span style={this.state.selectDayInvalid ? 
                    {color:'red', textDecoration:'underline', fontWeight: 'bold'}: 
                    {color:'black', textDecoration:'none'}}>금식 날:</span>
                </td>
                <td width="280px">
                  <select name="selectDay" value={this.state.selectDay} 
                    onChange={this.captureInput} 
                    style={{width: '200px', height: '30px'}}>
                    <option>- 선택 하기 -</option>
                    <option>일요일 (Sun)</option>
                    <option>월요일 (Mon)</option>
                    <option>화요일 (Tue)</option>
                    <option>수요일 (Wed)</option>
                    <option>목요일 (Thu)</option>
                    <option>금요일 (Fri)</option>
                    <option>토요일 (Sat)</option>
                  </select>
                </td>
              </tr>
            </tbody></table>
            <br />
            <br />
            <table><tbody><tr>
              <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.registerDay()}>등록 확인</button></td>
              <td width="10px" />
              <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.setState({showOption: '', userName: '', userTitle: '', selectDay: 0, selectMeal: 0, userNameInvalid: false, selectDayInvalid: false, selectMealInvalid: false})}>등록 취소</button></td>
            </tr></tbody></table>
          </div>
        )}

        {this.state.showOption === 'meal' && (
          <div>
          <hr/>
          <table><tbody>
            <tr>
            <td width="100px">
                  <span style={this.state.userNameInvalid ? 
                    {color:'red', textDecoration:'underline', fontWeight: 'bold'}: 
                    {color:'black', textDecoration:'none'}}>이름:</span>
                </td>
                <td width="280px">
                  <input type="text" name="userName" 
                    value={this.state.userName} 
                    onChange={this.captureInput}
                    style={{width: '200px'}} />
                  </td>
                <td width="100px">직분:</td>
                <td width="280px">
                  <input type="text" name="userTitle" 
                    value={this.state.userTitle} 
                    onChange={this.captureInput}
                   style={{width: '200px'}} />
                </td>
            </tr>
          </tbody></table>
          <hr/>
          <br />
          <b>주중 한끼 금식</b>
          <br />
          <br />
          <table style={{marginLeft: '20px'}}><tbody>
            <tr>
              <td width="100px">
                <span style={this.state.selectDayInvalid ? 
                  {color:'red', textDecoration:'underline', fontWeight: 'bold'}: 
                  {color:'black', textDecoration:'none'}}>금식 날:</span>
              </td>
              <td width="280px">
                <select name="selectDay" value={this.state.selectDay} 
                  onChange={this.captureInput} 
                  style={{width: '200px', height: '30px'}}>
                  <option>- 선택 하기 -</option>
                  <option>일요일 (Sun)</option>
                  <option>월요일 (Mon)</option>
                  <option>화요일 (Tue)</option>
                  <option>수요일 (Wed)</option>
                  <option>목요일 (Thu)</option>
                  <option>금요일 (Fri)</option>
                  <option>토요일 (Sat)</option>
                </select>
              </td>
            </tr>
          </tbody></table>
          <table style={{marginLeft: '20px'}}><tbody>
            <tr>
              <td width="100px">
                <span style={this.state.selectMealInvalid ? 
                  {color:'red', textDecoration:'underline', fontWeight: 'bold'}: 
                  {color:'black', textDecoration:'none'}}>금식 시간:</span>
              </td>
              <td width="280px">
                <select name="selectMeal" value={this.state.selectMeal} 
                  onChange={this.captureInput} 
                  style={{width: '200px', height: '30px'}}>
                  <option>- 선택 하기 -</option>
                  <option>아침 (Breakfast)</option>
                  <option>점심 (Lunch)</option>
                  <option>저녁 (Dinner)</option>
                </select>
              </td>
            </tr>
          </tbody></table>
          <br />
          <br />
          <table><tbody><tr>
            <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.registerMeal()}>등록 확인</button></td>
            <td width="10px" />
            <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.setState({showOption: '', userName: '', userTitle: '', selectDay: 0, selectMeal: 0, userNameInvalid: false, selectDayInvalid: false, selectMealInvalid: false})}>등록 취소</button></td>
          </tr></tbody></table>
        </div>
        )}

        {this.state.showOption === 'confirmation' && (
          <div>
            <hr/>
            <br />
            <BigBold>등록되었습니다!</BigBold>
            <br />
            <br />
            <hr/>
            <table><tbody>
              <tr>
                <td width="100px">이름:</td>
                <td width="280px">{this.state.userName}</td>
              </tr>
              <tr>
                <td width="100px">직분:</td>
                <td width="280px">{this.state.userTitle}</td>
              </tr>
              <tr>
                <td width="100px">금식 날:</td>
                <td width="280px">{this.state.selectDay}</td>
              </tr>
              {(this.state.selectMeal !== 0) ? (
                <tr>
                  <td width="100px">금식 시간:</td>
                  <td width="280px">{this.state.selectMeal}</td>
                </tr>
              ):(<></>)}
            </tbody></table>
            <br />
            <BigBold>참여요령:</BigBold> 
            <br />
            ● 우선 매주 나라를 위하여 하루 금식 혹은 한끼 금식을 할 것인지 하나님앞에서 결정한다. <br />
            ● 그 시로부터 해당하는 매주 요일에 하나님앞에 금식하며 나라를 위하여 기도한다. <br />
            ● 나라를 위하여 기도할 때에 여기에 자세한 구국 기도문을 제시하고 있으므로 그것에 따라서 읽으면서 기도한다. <br />
            <br />
            <br />
            <button className="btn btn-primary" onClick={() => this.props.history.push("/")}>홈 페이지</button>

          </div>
        )}

      </div>
    );
  }
}
